module.exports = __webpack_public_path__ + "static/media/cashSound.bc577e61.wav";